import { Component, Input } from '@angular/core';
import { WHATSAPP } from '../../../constants/whatsapp';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'allas-product-price',
  imports: [CommonModule],
  template: `
    @if (price > 0) {
    <!-- Price -->
    <div class="flex gap-0 justify-start mb-2 text-right w-full">
      <span
        class="self-start text-gray-500 font-bold fs-condensed"
        [class.text-xs]="size === 'sm'"
        [class.text-md]="size === 'md'"
      >
        L.
      </span>
      <span
        class="text-appPrimary-500 font-extrabold fs-condensed"
        [class.text-2xl]="size === 'md'"
        [class.text-lg]="size === 'sm'"
      >
        {{ getIntFormattedPrice() }}
      </span>
      <span
        class="self-start text-gray-500 font-bold fs-condensed"
        [class.text-xs]="size === 'sm'"
        [class.text-md]="size === 'md'"
        *ngIf="getOnlyDecimalPrice()"
      >
        .{{ getOnlyDecimalPrice() }}
      </span>
    </div>
    } @else {
    <!-- Si no tiene precio, mostrar un mensaje de contactar por whatsapp -->
    <a
      [href]="whatsapp.url('Hola, necesito cotizar un producto. ¿Podrían ayudarme?')"
      target="_blank"
      class="flex items-center gap-2 text-sm text-gray-900/80 transition-colors p-1 px-3 bg-gray-100 hover:bg-gray-200 rounded-md border border-gray-200"
    >
      <img
        src="/allas-icons/whatsapp.svg"
        alt="Icono de WhatsApp"
        width="24"
        height="24"
        [class.h-12]="size === 'md'"
        [class.h-6]="size === 'sm'"
      />
      <span>
        Este producto no tiene precio disponible, por favor contacta a nuestro
        equipo de ventas para obtener más información.
      </span>
    </a>
    }
  `,
})
export class ProductPrice {
  readonly whatsapp = WHATSAPP;
  @Input() price = 0;
  @Input() size: 'sm' | 'md' = 'md';

  getIntFormattedPrice(): string {
    // Sin redondear a nada, solo quitar los decimales, agregar las comas para separar los miles
    const intPrice = Number(this.price.toString().split('.')[0]);
    return intPrice.toLocaleString('es-CO').replace(/\./g, ',');
  }

  getOnlyDecimalPrice(): string {
    const priceStr = this.price.toString();
    const parts = priceStr.split('.');

    if (parts.length === 1) {
      return '00';
    }

    const decimal = parts[1];
    // Limitar a máximo 2 decimales y eliminar ceros innecesarios
    const limitedDecimal = decimal.substring(0, 2);

    // Si solo hay un decimal, agregar un cero
    return limitedDecimal.length === 1 ? `0${limitedDecimal}` : limitedDecimal;
  }
}
